import type { AuthUser } from "@perlab/auth-bridge";

/** Client state isolation only; the server remains authoritative for access and freshness. */
export function authAccessIdentity(user: AuthUser | null): string | null {
  if (!user?.userId) return null;
  return JSON.stringify([user.tenant, user.userId, [...new Set(user.roles)].sort()]);
}
